export const JOB_LOAD_REQUEST = "JOB_LOAD_REQUEST";
export const JOB_LOAD_SUCCESS = "JOB_LOAD_SUCCESS";
export const JOB_LOAD_FAIL = "JOB_LOAD_FAIL";
export const JOB_LOAD_RESET = "JOB_LOAD_RESET";

export const JOB_REGISTER_REQUEST = "JOB_REGISTER_REQUEST";
export const JOB_REGISTER_SUCCESS = "JOB_REGISTER_SUCCESS";
export const JOB_REGISTER_FAIL = "JOB_REGISTER_FAIL";
export const JOB_REGISTER_RESET = "JOB_REGISTER_RESET";

export const JOB_DETAILS_REQUEST = "JOB_DETAILS_REQUEST"
export const JOB_DETAILS_SUCCESS = "JOB_DETAILS_SUCCESS"
export const JOB_DETAILS_FAIL = "JOB_DETAILS_FAIL"
export const JOB_DETAILS_RESET = "JOB_DETAILS_RESET"

export const JOB_POSTED_REQUEST = "JOB_POSTED_REQUEST"
export const JOB_POSTED_SUCCESS = "JOB_POSTED_SUCCESS"
export const JOB_POSTED_FAIL = "JOB_POSTED_FAIL"
export const JOB_POSTED_RESET = "JOB_POSTED_RESET"

export const JOB_STATUS_REQUEST = "JOB_STATUS_REQUEST"
export const JOB_STATUS_SUCCESS = "JOB_STATUS_SUCCESS"
export const JOB_STATUS_FAIL = "JOB_STATUS_FAIL"
export const JOB_STATUS_RESET = "JOB_STATUS_RESET"

export const EXPIRE_REQUEST = "EXPIRE_REQUEST"
export const EXPIRE_SUCCESS = "EXPIRE_SUCCESS"
export const EXPIRE_FAIL = "EXPIRE_FAIL"
export const EXPIRE_RESET = "EXPIRE_RESET"

export const HIRE_REQUEST = "HIRE_REQUEST"
export const HIRE_SUCCESS = "HIRE_SUCCESS"
export const HIRE_FAIL = "HIRE_FAIL"
export const HIRE_RESET = "HIRE_RESET"